module.exports = "/images/calendar-green.svg?d2a09b974ef5a2729e3a80f9d44436d6";